import { ExitButton } from "../../components/Custom/Buttons";
import PreviewToggleButtons from "../../components/PreviewToggleButtons";
import UndoRedoComponent from "../../components/UndoRedoComponent/index";

import {
  BodyHeaderContainer,
  BodyHeaderInnerGrid,
  DeviceContainer,
  ExitContainer,
  UndoRedoContainer,
} from "./styled";

export default function FormBodyHeader({
  handleUndo,
  handleRedo,
  undoDisabled,
  redoDisabled,
  previewType,
  setPreviewType,
  onExitClick,
}: any) {
  return (
    <BodyHeaderContainer>
      <BodyHeaderInnerGrid container>
        <UndoRedoContainer item xs={4}>
          <UndoRedoComponent
            handleUndo={handleUndo}
            handleRedo={handleRedo}
            undoDisabled={undoDisabled}
            redoDisabled={redoDisabled}
          />
        </UndoRedoContainer>
        <DeviceContainer item xs={4}>
          <PreviewToggleButtons 
            previewType={previewType}
            setPreviewType={setPreviewType}
          />
        </DeviceContainer>
        <ExitContainer item xs={4}>
          {!sessionStorage.getItem("noWorkspace") && (
            <ExitButton onClick={onExitClick} />
          )}
        </ExitContainer>
      </BodyHeaderInnerGrid>
    </BodyHeaderContainer>
  );
}
